import React from 'react';

const Location = () => {
  const openMaps = () => {
    window.open('https://www.google.com/maps/search/?api=1&query=Kyle+Rise+Car+Park+Ayr', '_blank');
  };

  return (
    <section id="contact" className="relative py-16 bg-[#0a1628]">
      {/* Decorative road curves - bottom left */}
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 opacity-10 pointer-events-none">
        <svg viewBox="0 0 400 400" className="w-full h-full">
          <path d="M0,200 Q100,250 0,300" stroke="#334155" strokeWidth="50" fill="none" strokeDasharray="25,15"/>
        </svg>
      </div>

      {/* Decorative car - bottom right */}
      <div className="absolute bottom-10 right-10 w-20 h-20 opacity-20">
        <div className="text-6xl transform rotate-45">🚗</div>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left: Content */}
          <div>
            <p className="text-xs font-bold text-white/60 uppercase tracking-widest mb-3">
              FIND US
            </p>
            <h2 className="text-3xl sm:text-4xl font-black text-white mb-6">
              Easy to Find <span className="text-[#00d4ff]">Right in Ayr</span>
            </h2>

            <div className="flex items-start gap-3 mb-6">
              <svg className="w-6 h-6 text-[#00d4ff] flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <div className="text-white">
                <p className="font-bold text-base">Kyle Rise Car Park, just off Carrick Street, Ayr</p>
              </div>
            </div>

            <p className="text-white/80 text-base mb-8 leading-relaxed">
              A central location with easy access and a unique driving environment in the heart of Ayr.
            </p>

            <button
              onClick={openMaps}
              className="group px-6 py-3 bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] hover:from-[#0284c7] hover:to-[#0891b2] text-white font-bold rounded-lg transition-all shadow-lg flex items-center gap-2"
            >
              Get Directions
              <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>

          {/* Right: Map */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur rounded-2xl p-4 border-2 border-[#00d4ff]/20 shadow-xl">
              <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden relative">
                <iframe
                  title="Kyle Rise Car Park, Ayr"
                  src="https://www.google.com/maps?q=Kyle+Rise+Car+Park,+Carrick+Street,+Ayr&output=embed"
                  className="absolute inset-0 w-full h-full border-0"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
